module.exports = __webpack_public_path__ + "static/almond-6521827b08eb5ec3b8a870afac06cfbc.svg";